import React from 'react';
import type { IntlShape } from 'react-intl';

export const SearchQueryContext = React.createContext<{
  searchQuery: string;
  intl: IntlShape;
} | null>(null);
